import React from 'react';
import PageApp from '../../../Page';
import { Table, Button, message, Popconfirm, Space } from 'antd';
import { HomeOutlined, UnorderedListOutlined, ScheduleOutlined } from '@ant-design/icons';
import { getAll, remove } from '../../../../apis/DiasFestivosApi';
import AddHoliday from './add';

const monthName = (m) => {
  if (!m) return '';
  const es = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
  return es[(m - 1) % 12];
};

const HolidaysPage = () => {
  const [items, setItems] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  // Drawer (add/edit)
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [selectedHoliday, setSelectedHoliday] = React.useState(null);

  // Eliminar (loader por fila)
  const [deletingId, setDeletingId] = React.useState(null);

  // Para evitar doble ejecución en StrictMode
  const effectRan = React.useRef(false);

  const routes = [
    { href: '', title: <><HomeOutlined /><span>Inicio</span></> },
    { href: '', title: <><UnorderedListOutlined /><span>Configuración</span></> },
    { href: '', title: <><UnorderedListOutlined /><span>Asistencia</span></> },
    { href: '', title: <><ScheduleOutlined /><span>Días Festivos</span></> },
  ];

  const onOpenAdd = () => {
    setSelectedHoliday(null);
    setOpenDrawer(true);
  };

  const onOpenEdit = (row) => {
    setSelectedHoliday(row?._raw || row);
    setOpenDrawer(true);
  };

  const onCloseDrawer = () => {
    setOpenDrawer(false);
    setSelectedHoliday(null);
  };

  const handleDelete = async (row) => {
    try {
      setDeletingId(row.id);
      await remove(row.id);
      message.success('Festivo eliminado');
      await refreshData();
    } catch {
      message.error('No se pudo eliminar el festivo');
    } finally {
      setDeletingId(null);
    }
  };

  const columns = [
    { title: 'Festivo', dataIndex: 'festivo', key: 'festivo' },
    { title: 'Mes', dataIndex: 'mes', key: 'mes' },
    { title: 'Día', dataIndex: 'dia', key: 'dia' },
    { title: 'Fecha Inicial', dataIndex: 'fecha_inicial', key: 'fecha_inicial' },
    { title: 'Fecha Final', dataIndex: 'fecha_final', key: 'fecha_final' },
    { title: 'Horario', dataIndex: 'horario', key: 'horario' },
    {
      title: '',
      key: 'actions',
      width: 180,
      align: 'right',
      render: (_, record) => (
        <Space>
          <Button type="primary" size="small" onClick={() => onOpenEdit(record)}>
            Editar
          </Button>
          <Popconfirm
            title="Eliminar festivo"
            description="¿Seguro que deseas eliminar este festivo?"
            okText="Sí, eliminar"
            cancelText="Cancelar"
            onConfirm={() => handleDelete(record)}
          >
            <Button
              danger
              size="small"
              loading={deletingId === record.id}
              disabled={deletingId === record.id}
            >
              Eliminar
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const mapToRows = (arr) =>
    (arr || []).map((d) => ({
      id: d.id,
      festivo: d.name || d.display_name || '(sin nombre)',
      mes: monthName(d.month),
      dia: d.day ?? '',
      fecha_inicial: d.date_from || '',
      fecha_final: d.date_to || '',
      horario: d?.calendar?.name || (d?.calendar?.id ? `Calendario #${d.calendar.id}` : '-'),
      _raw: d,
    }));

  const normalizeResponse = (resp) => {
    if (Array.isArray(resp)) return resp;
    if (resp && Array.isArray(resp.payload)) return resp.payload;
    return [];
  };

  const refreshData = async () => {
    try {
      setLoading(true);
      const resp = await getAll();
      const data = normalizeResponse(resp);
      setItems(mapToRows(data));
    } catch {
      message.error('No se pudo cargar la lista de festivos');
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    if (!effectRan.current) {
      (async () => {
        await refreshData();
      })();
    }
    return () => {
      effectRan.current = true;
    };
  }, []);

  return (
    <PageApp routes={routes}>
      <div style={{ marginBottom: 12 }}>
        <Button type="primary" onClick={onOpenAdd}>Agregar Día Festivo</Button>
      </div>

      <Table
        rowKey="id"
        dataSource={items}
        columns={columns}
        loading={loading}
      />

      <AddHoliday
        open={openDrawer}
        holiday={selectedHoliday}
        onClose={onCloseDrawer}
        onSaved={async () => {
          await refreshData();
          onCloseDrawer();
        }}
      />
    </PageApp>
  );
};

export default HolidaysPage;